import { useEffect, useState } from 'react'
import {
  GridApi,
  useGridSelector,
  selectedGridRowsCountSelector,
} from '@mui/x-data-grid-pro'

type ColumnSortMap = Record<string, boolean | undefined>

export const useDisableColumnSort = (
  apiRef: React.MutableRefObject<GridApi>,
) => {
  const selectedRowsCount = useGridSelector(
    apiRef,
    selectedGridRowsCountSelector,
  )

  const [prevSortValues, setPrevSortValues] = useState<ColumnSortMap>()

  useEffect(() => {
    if (!apiRef.current || !apiRef.current.getAllColumns) {
      return
    }

    const columns = apiRef.current.getAllColumns()
    if (selectedRowsCount > 0 && prevSortValues === undefined) {
      setPrevSortValues(
        columns.reduce<ColumnSortMap>(
          (p, { field, sortable }) => ({ ...p, [field]: sortable }),
          {},
        ),
      )

      apiRef.current.updateColumns(
        columns.map((c) => ({ ...c, sortable: false })),
      )
    } else if (selectedRowsCount === 0 && prevSortValues !== undefined) {
      apiRef.current.updateColumns(
        columns.map((c) => ({ ...c, sortable: prevSortValues[c.field] })),
      )
      setPrevSortValues(undefined)
    }
  }, [apiRef, prevSortValues, selectedRowsCount])
}
